import React from 'react'
import { Link } from 'react-router-dom'

function AddEnergyBtn() {
    return (
        <>
            <div className="become-a-seller-btn">
                <Link to="/add-energy">
                    <button className='btn become-a-seller-btn me-3'>Add Energy</button>
                </Link>
            </div>
        </>
    )
}

export default AddEnergyBtn
